import { createSelector } from '@reduxjs/toolkit'

import { selectMarketYoyGrowthExpectationState } from './selectMarketYoyGrowthExpectationState'

/** The `Log` audit trail for the current planning entry. */
export const selectMarketYoyGrowthExpectationLog = createSelector(
  [selectMarketYoyGrowthExpectationState],
  (state) => state.log
)
